import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Email,EmailData } from '../data/email';
import { MessageHandlerService } from "../../services/message-handler.service"
import { EventEmitter } from '@angular/core';

@Injectable()
export class EmailService extends EmailData {

  emitter: EventEmitter<any> = new EventEmitter();
  api: string;
  apiForm: string;
  header: any;
  constructor(private http: HttpClient, private messageHandler: MessageHandlerService) {
    super();
    this.api = environment.apiUrl;
  }


  async deleteEmail(id?) {
    try {
      let flyers = await this.http.delete(this.api + "email/" + (id || "")).toPromise();
      return flyers
    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }


  async createEmail(data) {
    try {

      let response = await this.http.post(this.api + "email", data).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async getEmails(pagination, filter, order) {
    console.log({ pagination, filter, order });
    try {
      let response = await this.http.post(this.api + "emails", { pagination, filter, order }).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async getEmail(id: string) {
    try {

      let email = <Email>await this.http.get(this.api + "email/" + id).toPromise();
      return email

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async editEmail(data, id?: string) {
    try {

      let response = <Email>await this.http.put(this.api + "email/" + (id || ''), data).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

}
